


import {
  defineComponent,
  PropType,
  ref,
} from '@vue/composition-api';
import {
  MAX_SAVABLE_FILES_COUNT,
  isImageFileType,
  fileTypeIconFromFilePath,
} from '@/lib/fileHelper';
import { CandidateFile } from '@/models';

export default defineComponent({
  props: {
    previewFiles: {
      type: Array as PropType<CandidateFile[]>,
      required: true,
    },
    isChangeable: {
      type: Boolean,
      default: true,
    },
    acceptedFileTypes: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const refUploadFile = ref<HTMLInputElement>();
    const handleFileUpload = () => {
      const fileList = refUploadFile.value?.files;
      if (!fileList) return;
      emit('file-upload', fileList);
    };
    const removeFile = (fileId: number) => {
      if (refUploadFile.value) {
        refUploadFile.value.value = '';
      }
      emit('remove-file', fileId);
    };
    return {
      MAX_SAVABLE_FILES_COUNT,
      // refs
      refUploadFile,
      handleFileUpload,
      removeFile,
      isImageFileType,
      fileTypeIconFromFilePath,
    };
  },
});
